import React, { useState } from "react";
import LinkIcon from "@atlaskit/icon/core/link";
import { extractAppUrl } from "../../connections/atlassian/jira/jiraPathExtractor";
import { useSelector } from "react-redux";
import Tooltip from "@atlaskit/tooltip";

const ShareFlowLink = ({ flowId, className }) => {
  const appWebLocation = useSelector((state) => state.jira.appWebLocation);

  return (
    <Tooltip content="This is a shareable link. You can send it to your friends or colleagues so they can access the same content.">
      <a
        href={`${extractAppUrl(appWebLocation)}/integration/${flowId}`}
        target="_blank"
        className="atlassian-link"
      >
        <div className={className}>
          <LinkIcon label="" />
        </div>
      </a>
    </Tooltip>
  );
};
export default ShareFlowLink;
